module.exports = __webpack_public_path__ + "img/job-seekers.4a5b832a.png";